module.exports = __webpack_public_path__ + "img/audio-volume-medium-symbolic.6b13d532.svg";